import axios from 'axios';
import { API_HOST } from '../consts';

const fetchNationalityOptions = async (params) => {
  const res = await axios.get(`${API_HOST}/cities/nationality`, { params });
  return res.data;
};

export default fetchNationalityOptions;
